import { useCallback } from 'react';
import copyToClipboard from 'copy-to-clipboard';

import WpToastManager from 'Wpds/components/toast/WpToastManager';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

type Params = {
  textToCopy: string;
  successMessage?: string;
};

export function useCopyToClipboard({ textToCopy, successMessage }: Params) {
  const { tr } = useTranslation();
  const resolvedSuccessMessage = successMessage ?? tr('perform.common.clipboard.link_copied');
  const sendSuccess = useCallback(() => WpToastManager.success(resolvedSuccessMessage), [resolvedSuccessMessage]);

  const sendError = useCallback(() => WpToastManager.danger(tr('perform.common.clipboard.copy_error')), [tr]);

  const handleCopyTextToClipboard = useCallback(() => {
    try {
      copyToClipboard(textToCopy);
      sendSuccess();
    } catch {
      sendError();
    }
  }, [sendSuccess, textToCopy, sendError]);

  return { onCopyTextToClipboard: handleCopyTextToClipboard };
}
